var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center",class:`sumo-bg-${_vm.bannerDetails.bg_color}`},[_c('DealBannerContent',{attrs:{"banner-details":_vm.bannerDetails,"tooltip-id":"mobile-deal-banner-tooltip"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }